var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 313,
    height: 404,
    viewBox: "0 0 313 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M146.574 123.837C173.957 107.856 196.594 122.792 200.599 157.279C201.295 163.244 196.768 171.126 191.239 174.348L101.91 226.514C96.3813 229.736 91.8539 227.124 92.5504 220.331C96.5554 181.272 119.236 139.818 146.574 123.837Z",
    fill: "url(#paint0_linear_45_2597)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M116.058 79.0734C116.058 102.892 129.814 114.126 146.792 104.198C163.77 94.2703 177.526 66.9681 177.526 43.1494C177.526 19.3307 163.77 8.09633 146.792 18.0244C129.814 27.9525 116.058 55.2547 116.058 79.0734Z",
    fill: "url(#paint1_linear_45_2597)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M128.987 109.554C156.369 93.5736 179.006 108.509 183.011 142.996C183.708 148.962 179.181 156.843 173.652 160.066L84.3228 212.232C78.7942 215.454 74.2668 212.841 74.9633 206.048C78.9683 166.989 101.605 125.535 128.987 109.554Z",
    fill: "url(#paint2_linear_45_2597)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M98.4709 64.7909C98.4709 88.6096 112.227 99.844 129.205 89.9159C146.183 79.9878 159.939 52.6856 159.939 28.8669C159.939 5.04826 146.183 -6.18614 129.205 3.74194C112.227 13.67 98.4709 40.9722 98.4709 64.7909Z",
    fill: "url(#paint3_linear_45_2597)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.31 246.651C39.31 245.049 40.1644 243.569 41.5515 242.768L109.941 203.271C112.93 201.544 116.668 203.702 116.668 207.154V239.708L39.31 284.384V246.651Z",
    fill: "url(#paint4_linear_45_2597)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.952 221.985C100.952 225.295 102.911 226.862 105.349 225.469C107.787 224.076 109.746 220.244 109.746 216.934C109.746 213.625 107.787 212.057 105.349 213.451C102.911 214.844 100.952 218.676 100.952 221.985Z",
    fill: "#E559F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M96.8603 220.548L73.6138 234.004V238.837L96.9038 225.382L96.8603 220.548Z",
    fill: "#FEFEFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M96.8602 230.259L47.32 258.867V263.788L96.8602 235.179V230.259Z",
    fill: "#FEFEFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M196.463 200.06C196.463 198.457 197.318 196.977 198.706 196.176L267.095 156.717C270.085 154.993 273.821 157.15 273.821 160.601V193.159L196.463 237.835V200.06Z",
    fill: "url(#paint5_linear_45_2597)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M258.105 175.393C258.105 178.703 260.064 180.27 262.502 178.877C264.94 177.483 266.899 173.651 266.899 170.342C266.899 167.033 264.94 165.465 262.502 166.859C260.064 168.252 258.105 172.084 258.105 175.393Z",
    fill: "#835AFD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M254.144 174.174L240.126 182.273V187.194L254.144 179.094V174.174Z",
    fill: "#FEFEFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M254.013 183.884L204.473 212.493V217.413L254.013 188.805V183.884Z",
    fill: "#FEFEFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M146.614 249.832C146.616 246.378 142.878 244.219 139.887 245.946L2.28352 325.416C0.897217 326.216 0.0428925 327.695 0.0419769 329.296L-7.62939e-05 403.129L133.645 325.969L144.617 329.553C145.583 329.869 146.575 329.149 146.575 328.133L146.614 249.832Z",
    fill: "url(#paint6_linear_45_2597)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M116.842 284.863C116.842 291.177 120.542 294.095 125.156 291.438C129.771 288.782 133.471 281.51 133.471 275.24C133.471 268.926 129.771 266.009 125.156 268.665C120.586 271.321 116.842 278.593 116.842 284.863Z",
    fill: "#E559F9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M108.919 282.425L76.7917 300.975V307.68L108.919 289.131V282.425Z",
    fill: "#FEFEFE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M108.919 295.88L12.9728 351.268V357.974L108.919 302.586V295.88Z",
    fill: "#FEFEFE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M108.919 309.335L33.9121 352.662V359.367L108.919 316.041V309.335Z",
    fill: "#FEFEFE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.424 266.593C166.425 264.992 167.28 263.512 168.667 262.712L306.27 183.284C309.26 181.558 312.997 183.717 312.996 187.17L312.956 255.819L179.311 332.979L169.118 348.084C168.293 349.307 166.384 348.722 166.384 347.248L166.424 266.593Z",
    fill: "url(#paint7_linear_45_2597)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M196.202 272.41C196.202 278.723 192.458 285.952 187.887 288.608C183.273 291.264 179.572 288.303 179.572 281.989C179.572 275.675 183.316 268.447 187.887 265.791C192.458 263.178 196.202 266.139 196.202 272.41Z",
    fill: "#835AFD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M204.125 260.87L236.252 242.321V249.026L204.125 267.576V260.87Z",
    fill: "#FEFEFE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M204.081 274.282L300.027 218.894V225.6L204.125 280.988L204.081 274.282Z",
    fill: "#FEFEFE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M204.081 287.737L279.088 244.411V251.116L204.081 294.443V287.737Z",
    fill: "#FEFEFE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M251.967 311.599C249.355 313.08 247.266 316.738 247.266 319.786V333.067L238.472 338.118C235.86 339.598 233.771 343.256 233.771 346.26C233.771 349.265 235.86 350.484 238.472 349.004L247.266 343.909V357.19C247.266 360.195 249.355 361.414 251.967 359.933C254.579 358.453 256.669 354.795 256.669 351.791V338.51L265.462 333.459C268.074 331.978 270.164 328.32 270.164 325.316C270.164 322.311 268.074 321.092 265.462 322.572L256.669 327.624V314.343C256.712 311.295 254.579 310.075 251.967 311.599Z",
    fill: "url(#paint8_linear_45_2597)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62.8176 141.472L50.7156 165.247C49.0613 168.513 49.3225 171.779 51.325 172.563C53.3275 173.347 56.2877 171.3 57.942 168.034L58.0726 167.729V194.117C58.0726 197.122 60.1621 198.341 62.7741 196.86C65.3861 195.336 67.4756 191.722 67.4756 188.718V162.33L67.6062 162.461C69.2605 163.81 72.2642 162.417 74.2232 159.325C76.2257 156.234 76.4869 152.663 74.8327 151.313L62.8176 141.472Z",
    fill: "url(#paint9_linear_45_2597)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_2597",
    x1: 33.6176,
    y1: 97.7763,
    x2: 144.84,
    y2: 178.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45_2597",
    x1: 90.2879,
    y1: 19.8906,
    x2: 201.51,
    y2: 101.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_45_2597",
    x1: 16.023,
    y1: 83.4889,
    x2: 127.245,
    y2: 164.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_45_2597",
    x1: 72.6933,
    y1: 5.60276,
    x2: 183.915,
    y2: 86.7144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_45_2597",
    x1: 69.2705,
    y1: 226.769,
    x2: 86.7271,
    y2: 257.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_45_2597",
    x1: 226.423,
    y1: 180.183,
    x2: 243.88,
    y2: 210.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_45_2597",
    x1: 83.6607,
    y1: 244.547,
    x2: 64.6993,
    y2: 398.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_45_2597",
    x1: 198.387,
    y1: 233.403,
    x2: 274.093,
    y2: 292.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_45_2597",
    x1: 242.889,
    y1: 328.562,
    x2: 265.686,
    y2: 346.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_45_2597",
    x1: 54.2151,
    y1: 165.456,
    x2: 76.298,
    y2: 177.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.506d3c00042c88962e5580f84f9bc052.svg";
export { ForwardRef as ReactComponent };